import ImageWithFallback from 'components/ImageWithFallback';
import { ReactElement } from 'react';
import styles from './YourPerks.module.css';
import { YourPerksCarousel } from './YourPerksCarousel';
import { filterPerksByTestGroup } from './constants';

export const PerkItem = ({
  imageSrc,
  header,
  description,
}: {
  imageSrc: string;
  header: string;
  description: ReactElement;
}) => {
  return (
    <div className={styles.perkItemContainer}>
      <div className={styles.perkIconContainer}>
        <ImageWithFallback layout="fill" src={imageSrc} />
      </div>
      <div className={styles.perkTextContainer}>
        <h4
          className={`aboutUsTypographyHeaderMedium noMargin alignLeftOnDesktop`}
        >
          {header}
        </h4>
        <p className={`noMargin textAlignCenter alignLeftOnDesktop`}>
          {description}
        </p>
      </div>
    </div>
  );
};

export const YourPerksList = ({
  isInMonthlyTestGroup,
}: {
  isInMonthlyTestGroup: boolean;
}) => {
  return (
    <div className={styles.perksContainer}>
      {filterPerksByTestGroup(isInMonthlyTestGroup).map((perk, index) => (
        <PerkItem
          key={index}
          imageSrc={perk.imageSrc}
          header={perk.header}
          description={perk.description}
        />
      ))}
    </div>
  );
};

export const YourPerks = ({
  isInMonthlyTestGroup,
}: {
  isInMonthlyTestGroup: boolean;
}) => {
  return (
    <div className={`${styles.perksInnerContent}`}>
      <h3
        data-text="Your Perks"
        className={`alignLeftOnDesktop aboutUsTypographyHeaderXlarge`}
      >
        Your Perks
      </h3>
      <div className={`desktopOnly`}>
        <YourPerksList isInMonthlyTestGroup={isInMonthlyTestGroup} />
      </div>
      <div className={`mobileOnly`}>
        <YourPerksCarousel isInMonthlyTestGroup={isInMonthlyTestGroup} />
      </div>
    </div>
  );
};
